import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { VideoPlayerComponent, VideoPlayerEvents, VideoPlayerSubscriber } from '../../video-player.component';
import { PopoverModule } from '@ngx-popovers/popover';
import { Arrow, MiddlewareList } from '@ngx-popovers/core';
import { offset } from '@floating-ui/dom';


@Component({
  selector: 'app-quality-control-selector',
  templateUrl: 'quality-control-selector.component.html',
  styleUrls: ['quality-control-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, PopoverModule, Arrow]
})
export class QualityControlSelectorComponent implements OnInit, OnChanges, VideoPlayerSubscriber {

  @Input() videoPlayerComponent: VideoPlayerComponent
  @Input() bindTo: string | HTMLElement | undefined;

  popovermiddleware: MiddlewareList = [
  ]

  private timeOut: NodeJS.Timeout = null;

  constructor() { }

  ngOnInit() {
    this.videoPlayerComponent.subscribeToVideoEvents(this);
  }

  ngOnChanges() {
    this.popovermiddleware = [
      offset(
        {
          crossAxis: this.videoPlayerComponent.isFullScreen() ? -20 : 20,
        }
      )
    ]
  }

  isMouseHoveringVideo(): boolean {
    return this.videoPlayerComponent.isMouseHovering;
  }

  notify(event: VideoPlayerEvents): void {

    if (event === VideoPlayerEvents.HOVER_IN) {
      // Clear focus on the settings button by clikking outside
      clearTimeout(this.timeOut);
    }

    if (event === VideoPlayerEvents.HOVER_OUT) {
      // Clear focus on the settings button by clikking outside
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        document.body.click();
      }
        , 1000);
    }
  }

}
